import React, { useEffect, useState } from "react";
import BoatCard from "./BoatCard";
import CreateBoat from "./CreateBoat";
import Loader from "./Loader";
import { useAdminContext } from "../../contexts/AdminContext";

import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";

const BoatsList: React.FC = () => {
  const { boatsQuery } = useAdminContext();

  const [refreshBoatsTrigger, setRefreshBoatsTrigger] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const handleBoatCreated = () => {
    setRefreshBoatsTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    boatsQuery.refetch();
  }, [refreshBoatsTrigger, boatsQuery.refetch]);

  const filteredBoats = boatsQuery.data?.bateaux?.filter((boat) =>
    boat.nom_bateau?.toLowerCase().includes(searchTerm.toLowerCase()) || boat.code_pf?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Card className="flex-fill">
      <Card.Header className="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <h2 className="mb-0 fs-2">Liste des Bateaux</h2>
        <CreateBoat onBoatCreated={handleBoatCreated} />
      </Card.Header>

      <Card.Body style={{ maxHeight: "100vh", overflowY: "auto" }}>
        <Form.Group className="mb-3" controlId="searchBoat">
          <Form.Control
            type="text"
            placeholder="Rechercher un bateau..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Form.Group>

        <Loader loading={boatsQuery.loading} error={boatsQuery.error}>
          <ListGroup variant="flush">
            {filteredBoats?.length ? (
              filteredBoats.map((boat) => (
                <BoatCard key={boat.id} boat={boat} />
              ))
            ) : (
              <p className="text-gray-500">Aucun bateau trouvé.</p>
            )}
          </ListGroup>
        </Loader>
      </Card.Body>
    </Card>
  );
};

export default BoatsList;
